import { render, staticRenderFns } from "./TwoColumnQuizReview.vue?vue&type=template&id=b89b24d0"
import script from "./TwoColumnQuizReview.vue?vue&type=script&lang=js"
export * from "./TwoColumnQuizReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports